import {TrackingActionType, TrackingAction} from './tracking.action';
import {initialTrackingState, TrackingState} from './tracking.state';

export function trackingReducer(state = initialTrackingState, action: TrackingAction): TrackingState {
  switch (action.type) {
    case TrackingActionType.GET_PIECES:
      return {...state, loaded: false};
    case TrackingActionType.GET_PIECES_SUCCESS:
      const piecesMap = {...state.piecesMap, [action.payload.searchValue]: action.payload.pieces};
      return {...state, loaded: true, piecesMap};
    default:
      return state;
  }
}
